import { useEffect } from 'react';
import { useRulesContext } from '../stores/rules-context';

function useRulesLoading(): void {
  const { fetchData } = useRulesContext();

  useEffect(() => {
    fetchData();
  }, [fetchData]);
}

export default useRulesLoading;
